import { render } from "./uni_file_field.vue?vue&type=template&id=0988052d"
import script from "./uni_file_field.vue?vue&type=script&lang=js"
export * from "./uni_file_field.vue?vue&type=script&lang=js"

import "./uni_file_field.vue?vue&type=style&index=0&id=0988052d&lang=less"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__